import React from 'react'

/* container */
import NewFaqContainer from '../../app-module-faq-container-new/default'
/* container */

import Contents from '../contents/contents'

import ScrollToTop from '../../../scrollToTop'

const index = (props) => {
  return (
    <NewFaqContainer {...props}>
      <ScrollToTop {...props} />
      <Contents {...props} />
    </NewFaqContainer>
  )
}

export default index
